import $http from '$http'
import { util } from 'utils';
export default {
    methods: {
        getList() {
            var obj = this.query;
            if (obj.createTimeStart != "" && obj.createTimeStart != undefined) {
                obj.createTimeStart = new Date(obj.createTimeStart).toLocaleDateString();
            }
            if (obj.createTimeEnd != "" && obj.createTimeEnd != undefined) {
                obj.createTimeEnd = new Date(obj.createTimeEnd).toLocaleDateString();
            }
            var props = {};
            for (var p in obj) {
                if (obj[p] != "") {
                    props[p] = obj[p];
                    Object.assign({}, props)
                }
            };
            this.lists = [];
            this.loading = true;//拼命加载中显示
            var a = { Sid: this.sysSid, Session: this.sysSession, pageIndex: this.pageIndex, pageSize: this.pageSize };
            var Params = Object.assign({}, a, props);
            $http.get("api/School/ZqwPlatform_GetOneSchoolHardList", Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false;//拼命加载中显示ss
                    this.lists = Data;
                    for (var i = 0; i < res.data.Data.length; i++) {
                        if (this.lists[i].CreateTime != "") {
                            this.lists[i].CreateTime = util.time2str(new Date(this.lists[i].CreateTime), 'short')
                        }
                    };
                });
            });
        },
        getFollowList(options) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: options.pageIndex || 1,
                pageSize: options.pageSize || 10,
                Customer_Id: options.id
            };
            $http.get('api/Follow/GetFollowList', Params).then(res => {
                let { Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.followUpTotalSize = Cnt;
                    this.followUpList = Data;
                });
            });
        },
        addFollowUpItem(data) {
            data.Customer_Id = this.currentId;
            $http.post('api/Follow/AddFollowEx', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.getFollowList({ id: this.currentId });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //获取跟进内容详情
        getFollowUpItem(id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: id
            };
            $http.get('api/Follow/GetFollowById', Params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.followItem = Data;
                });
            });
        },
        //更新跟进内容详情
        updateFollowUpItem(data) {
            $http.post('api/Follow/UpdateFollow', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.getFollowList({ id: this.currentId });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //删除跟进内容
        delFollowUpItem(id) {
            $http.post('api/Follow/DelFollow', { Id: id }).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getFollowList({ id: this.currentId });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        saveSubmit(Params) {
            $http.post("api/School/ZqwPlatform_AddSchool", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                    });
                    this.getList();
                    this.dialogVisible = false;
                });
            });
        },
        saveUpdate(Params) {
            $http.post("api/School/ZqwPlatform_UpdateSchool", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '更新成功',
                        type: 'success'
                    });
                    this.getList();
                    this.dialogVisible = false;
                })
            });
        },
        DeleteItem(item) {
            $http.post("api/School/ZqwPlatform_DelIntentionSchool", item).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "删除成功",
                        type: "success"
                    });
                    this.getList();
                })
            })
        },
        getOneDate(val) {
            var Params = { Sid: this.sysSid, Session: this.sysSession, Id: val }
            $http.get("api/School/ZqwPlatform_GetSchoolModel", Params).then(res => {
                util.doResult(this, res, () => {
                    let { Data } = res.data;
                    this.address.Provinces_Id = Data.Provinces_id;
                    this.address.City_Id = Data.City_id;
                    this.address.Area_Id = Data.Area_id;
                    this.form.AgentId = Data.AgentId;
                    this.form.AddPhoneNo = Data.Tel;
                    this.form.Weixin = Data.Weixin;
                    this.form.QQ = Data.QQ;
                    this.form.Email = Data.Email;
                    this.form.SchoolName = Data.SchoolName;
                    this.form.Address = Data.Address;
                    this.form.PrincipalName = Data.PrincipalName;
                    this.form.PhoneNo = Data.PhoneNo;
                    this.form.Id = Data.SchoolId;
                    this.form.SchoolId = Data.SchoolId
                });
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/school/purposeSchool/services.js